import "./SaberPage.css"
import { useState } from "react"
import saberFull from "./saber_full.png"
import PdfPageViewer from "./PdfPageViewer"

// Routed through a same-origin Netlify proxy (see public/_redirects) so the
// in-page PDF viewer can fetch it without hitting kidneycalc.org's CORS policy.
const MITE_SLIDES_SRC = "/media/mite_pres_10.2026.pdf"
const MITE_SLIDES_FALLBACK_HREF = "https://kidneycalc.org/saber/mite_pres_10.2026.pdf"

const GUIDELINE_LINKS = [
    {
        id: 1,
        label: "Tufts OVPE AI Guidelines",
        href: "https://ovpe.tufts.edu/initiatives/ai/ai-guidelines/",
    },
    {
        id: 2,
        label: "Guidance for Using AI at Tufts",
        href: "https://it.tufts.edu/ai/guidance-using-ai-tufts#choosinganaitool",
    },
    {
        id: 3,
        label: "MaineHealth Policies on AI",
        href: null,
        note: "(available via Intranet)",
    },
]

const LECTURE_PARTS = [
    {
        id: 1,
        label: "Part 1 - Concepts, Terms, and Tech",
        src: "https://kidneycalc.org/saber/Part_1_2026_AI_ICR_HAYDEN.mp4",
    },
    {
        id: 2,
        label: "Part 2 - AI in Medicine",
        src: "https://kidneycalc.org/saber/Part_2_2026_AI_ICR_HAYDEN.mp4",
    },
    {
        id: 3,
        label: "Part 3 - AI in Medical Education",
        src: "https://kidneycalc.org/saber/Part_3_2026_AI_ICR_HAYDEN.mp4",
    },
]

export default function SaberPage() {
    const [slidesOpen, setSlidesOpen] = useState(false)
    const [lectureOpen, setLectureOpen] = useState(false)
    const [openPart, setOpenPart] = useState(null)
    const [guidelinesOpen, setGuidelinesOpen] = useState(false)

    function handleSlidesToggle() {
        setSlidesOpen((current) => !current)
    }

    function handleGuidelinesToggle() {
        setGuidelinesOpen((current) => !current)
    }

    function handleLectureToggle() {
        setLectureOpen((current) => !current)
        setOpenPart(null)
    }

    function handlePartToggle(partId) {
        setOpenPart((current) => (current === partId ? null : partId))
    }

    return (
        <section className="saber-page-ctr">
            <div className="introduction">
                <h3>Responsible AI Use:</h3>
            </div>
            <div className="saber-content">
                <img className="saber-image" src={saberFull} alt="SABER" />
            </div>

   <br></br>
   <div className="explanation">

   <p>When considering the risks and limitations of any AI use case in medicine, reflect on each of the 5 domains within S.A.B.E.R. </p>
   </div>

   <br></br>

    <div className="review-domains">
    <p>SECURITY - Confidential or private data potentially exposed? Risks of HIPAA or FERPA violations avoided? </p>
    <p>ACCURACY - What type of model (deterministic vs. probabilistic)? Risk of hallucinations?</p>
    <p>BIAS - What is the risk of bias in the model? Automation bias in the user?</p>
    <p>ETHICS - How does the use of AI in this case hold up when considering principles of medical ethics? Patient consent / disclosure? User transparency? Accountability for outputs?</p>
    <p>RULES - Does the use case adhere to all pertinent institutional guidelines? Do policies conflict?</p>
    </div>

   <br></br>
   <br></br>

            <div className="saber-lecture-wrapper">
                <button
                    className={`saber-lecture-button ${slidesOpen ? "open" : ""}`}
                    onClick={handleSlidesToggle}
                    aria-expanded={slidesOpen}
                >
                    <span>View 2026 MITE Session Slides</span>
                    <span className="saber-chevron" aria-hidden="true" />
                </button>

                {slidesOpen && (
                    <div className="saber-pdf-wrapper">
                        <PdfPageViewer
                            src={MITE_SLIDES_SRC}
                            fallbackHref={MITE_SLIDES_FALLBACK_HREF}
                        />
                    </div>
                )}
            </div>

            <div className="saber-lecture-wrapper">
                <button
                    className={`saber-lecture-button ${lectureOpen ? "open" : ""}`}
                    onClick={handleLectureToggle}
                    aria-expanded={lectureOpen}
                >
        
                    <span>Watch 2026 AI Lecture</span>
                    <span className="saber-chevron" aria-hidden="true" />
                </button>

                {lectureOpen && (
                    <div className="saber-lecture-parts">
                        {LECTURE_PARTS.map((part) => {
                            const isOpen = openPart === part.id
                            return (
                                <div className="saber-lecture-part" key={part.id}>
                                    <button
                                        className={`saber-part-button ${isOpen ? "open" : ""}`}
                                        onClick={() => handlePartToggle(part.id)}
                                        aria-expanded={isOpen}
                                    >
                                        <span>{part.label}</span>
                                        <span className="saber-chevron" aria-hidden="true" />
                                    </button>

                                    {isOpen && (
                                        <div className="saber-video-wrapper">
                                            <video
                                                key={part.src}
                                                className="saber-video"
                                                src={part.src}
                                                controls
                                                autoPlay
                                            />
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>

            <div className="saber-lecture-wrapper">
                <button
                    className={`saber-lecture-button ${guidelinesOpen ? "open" : ""}`}
                    onClick={handleGuidelinesToggle}
                    aria-expanded={guidelinesOpen}
                >
                    <span>Links to Guidelines</span>
                    <span className="saber-chevron" aria-hidden="true" />
                </button>

                {guidelinesOpen && (
                    <ul className="saber-guideline-list">
                        {GUIDELINE_LINKS.map((link) => (
                            <li className="saber-guideline-item" key={link.id}>
                                {link.href ? (
                                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                                        {link.label}
                                    </a>
                                ) : (
                                    <span>
                                        {link.label} {link.note}
                                    </span>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </section>
    )
}
